export const obtenerRutaPublica = () => {
  const esResponsive = window.matchMedia("(max-width: 991.98px)").matches;
  const esAplicacionInstalada =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  return esResponsive || esAplicacionInstalada ? "/login" : "/";
};
